import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';

import useUserContext from 'ecommerce/context/user';

import PhotoGrid, { createGridItem, PHOTO_GRID_ACTION } from '../../../polotno/photos/photoGrid';
import ancestryApi, { ancestryMediaUrl, ancestryThumbUrl } from '../../../api/ancestry';

const AncestryMediaByPersonGrid = ({ columnCount, isVisible, onSelect, person, selectedIds }) => {
  const { accessToken } = useUserContext();

  const [gridItems, setGridItems] = useState([]);
  const [hasMore, setHasMore] = useState(accessToken != null);
  const [isLoadingState, setIsLoadingState] = useState(false);
  const isLoadingRef = useRef(false);

  const setIsLoading = value => {
    isLoadingRef.current = value;
    setIsLoadingState(value);
  };

  useEffect(() => {
    // Do nothing if another fetch is in progress, or there are no more items to fetch.
    if (isLoadingRef.current || !hasMore || !isVisible) {
      return;
    }
    // Prevent another invocation by setting the isLoading lock.
    setIsLoading(true);
    (async () => {
      const { data: photos, error } = await ancestryApi(accessToken).getPersonMedia(person.id);
      if (error) {
        console.error(error);
        setHasMore(false);
        setIsLoading(false);
        return;
      }

      setGridItems(
        photos.map(ancestryPhoto =>
          createGridItem({
            id: ancestryPhoto.id,
            label: ancestryPhoto.name,
            url: ancestryMediaUrl(ancestryPhoto.id, ancestryPhoto.fext),
            thumbUrl: ancestryThumbUrl(ancestryPhoto.id, ancestryPhoto.fext),
            custom: { ancestryPhoto },
          }),
        ),
      );
      setHasMore(false);
      setIsLoading(false);
    })();
    // TODO React to changes: person and authentication is now handled by parent components.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible]);

  return (
    <PhotoGrid
      columnCount={columnCount}
      empty={
        <div className="text-center">
          Sorry, we couldn&apos;t find any photos for {person.name}.
        </div>
      }
      hasMore={hasMore}
      isVisible={isVisible}
      isLoading={isLoadingState}
      items={gridItems}
      onSelect={({ item: { custom }, previewWidth, previewHeight }) => {
        onSelect({ ...custom, previewWidth, previewHeight, person });
      }}
      assetType="photo"
      selectedIds={selectedIds}
      actions={[PHOTO_GRID_ACTION.FAVORITE]}
    />
  );
};

AncestryMediaByPersonGrid.defaultProps = {
  selectedIds: {},
  columnCount: 2,
  isVisible: true,
  onSelect: () => {},
};

AncestryMediaByPersonGrid.propTypes = {
  selectedIds: PropTypes.object,
  columnCount: PropTypes.number,
  isVisible: PropTypes.bool,
  onSelect: PropTypes.func,
  person: PropTypes.object.isRequired,
};

export default AncestryMediaByPersonGrid;
